// src/components/HreflangTags.jsx

import { Helmet } from 'react-helmet';

function HreflangTags() {
  return (
    <Helmet>
      <link rel="alternate" hreflang="en-us"     href="https://carsnus.com/" />
      <link rel="alternate" hreflang="es-mx"     href="https://carsnus.pe/" />
      <link rel="alternate" hreflang="x-default" href="https://carsnus.com/" />
    </Helmet>
  );
}

export default HreflangTags;